module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3WZ59"))).then(() => parcelRequire('d0iPb'));